<script lang="ts">
import { defineComponent, reactive } from 'vue'
import PrDocumentCardBanners from '@/components/banner/PrDocumentCardBanners.vue'
import AsideAdBanner from '@/components/banner/AsideAdBanner.vue'
import RankingWeeklyForAside from '@/components/contents/RankingWeeklyForAside.vue'
import stateInitializer from '@/models/stateInitializer'

export default defineComponent({
  name: 'IndexAsideSecondary',

  components: {
    PrDocumentCardBanners,
    AsideAdBanner,
    RankingWeeklyForAside,
  },

  setup() {
    interface State {
      prSolutionContents: SolutionContentItem[],
    }

    const state: State = reactive({
      prSolutionContents: [],
    })

    stateInitializer(state, 'asideSecondary')

    return {
      // data
      state,
    }
  },
})
</script>

<template>
  <section class="section">
    <PrDocumentCardBanners :items="state.prSolutionContents" />
    <AsideAdBanner />
    <RankingWeeklyForAside />
  </section>
</template>
